import { deviationTypesFragment } from 'apollo/fragments/organization';
import { deviationsFragment } from 'apollo/fragments/deviations';
import { gql } from 'graphql.macro';

export const deviationTypesTemplate = gql`
    query deviationTypes {
        deviationTypes {
            ...deviationTypesFields
        }
    }
    ${deviationTypesFragment}
`;

export const deviationsTemplate = gql`
    query deviations($orderId: MongoDbObjectId!) {
        deviations(orderId: $orderId) {
            ...deviationsFields
        }
    }
    ${deviationsFragment}
`;

export const orderDeviationsTemplate = gql`
    query orderDeviations($orderId: MongoDbObjectId!) {
        orderDeviations(orderId: $orderId) {
            ...deviationsFields
        }
    }
    ${deviationsFragment}
`;
